export default "__VITE_ASSET__TCu_VQ9gb0SMB9N6E0hofg__";